// Blog data loader
// Loads all JSON blog posts from this folder via Vite import.meta.glob

const blogModules = import.meta.glob('./*.json', { eager: true, import: 'default' })

function filenameToSlug(filePath) {
  const fileName = filePath.split('/').pop() || ''
  return fileName.replace(/\.json$/i, '')
}

function normalizeBlog(rawBlog, filePath) {
  if (!rawBlog || typeof rawBlog !== 'object') return null

  const slug = rawBlog.slug || filenameToSlug(filePath)

  return {
    slug,
    title: rawBlog.title || slug,
    excerpt: rawBlog.excerpt || '',
    coverImage: rawBlog.coverImage || null,
    author: rawBlog.author || 'Polytoria Team',
    tags: Array.isArray(rawBlog.tags) ? rawBlog.tags : [],
    publishedAt: rawBlog.publishedAt || null,
    updatedAt: rawBlog.updatedAt || null,
    readingTime: rawBlog.readingTime || null,
    content: Array.isArray(rawBlog.content) ? rawBlog.content : [],
  }
}

export function getAllBlogs() {
  const blogs = Object.entries(blogModules)
    .map(([filePath, rawBlog]) => normalizeBlog(rawBlog, filePath))
    .filter(Boolean)
    .sort((a, b) => {
      const aTime = a.publishedAt ? new Date(a.publishedAt).getTime() : 0
      const bTime = b.publishedAt ? new Date(b.publishedAt).getTime() : 0
      return bTime - aTime
    })

  return blogs
}

export function getBlogBySlug(slug) {
  if (!slug) return null
  return getAllBlogs().find((b) => b.slug === slug) || null
}
